<template>
  <section id="howItWorks" class="relative">
    <img
      src="@images/landing-page/bubble.svg"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute -translate-x-[10rem] -translate-y-14 opacity-20 md:-translate-x-[20rem] lg:-translate-x-[10rem]"
      loading="lazy"
    />

    <div class="relative mx-auto max-w-[85rem] space-y-20 px-4">
      <div class="z-auto space-y-3">
        <h2 class="text-center font-exo-bold text-5xl text-balance uppercase lg:text-6xl">
          your <span class="bg-linear-to-r from-mauve-500 to-navy-blue-500 bg-clip-text text-transparent">ai dream team</span> in 3 steps
        </h2>
        <p class="text-center text-eerie-black-200">Three simple steps and your AI team is ready to vibe.</p>
      </div>
      <div>
        <div class="hidden gap-5 lg:grid lg:grid-cols-3 lg:gap-10">
          <div
            v-for="step in steps"
            :key="step.number"
            class="card flex flex-col justify-between gap-5 pb-0 transition-transform hover:-translate-y-1"
          >
            <div class="flex justify-between gap-7">
              <div class="space-y-4 pt-5">
                <h3 class="font-exo-bold text-xl capitalize md:text-2xl">{{ step.title }}</h3>
                <p class="text-sm text-pretty text-eerie-black-200 md:text-base">
                  {{ step.description }}
                </p>
              </div>
              <p class="font-exo-bold text-8xl leading-none text-eerie-black-200">{{ step.number }}</p>
            </div>

            <img :src="step.image" :alt="`VibeTeams ${step.title} Asset`" class="aspect-video object-cover object-top" loading="lazy" />
          </div>
        </div>

        <swiper-container pagination="true" space-between="30" class="mySwiper block lg:hidden">
          <swiper-slide v-for="step in steps" :key="step.number" class="card mb-16 grid gap-5">
            <div class="flex justify-between gap-7">
              <div class="space-y-4 pt-5">
                <h3 class="font-exo-bold text-xl capitalize md:text-2xl">{{ step.title }}</h3>
                <p class="text-sm text-pretty text-eerie-black-200 md:text-base">
                  {{ step.description }}
                </p>
              </div>
              <p class="font-exo-bold text-8xl leading-none text-eerie-black-200">{{ step.number }}</p>
            </div>

            <img
              :src="step.image"
              :alt="`VibeTeams ${step.title} Asset`"
              class="aspect-video object-cover object-top"
              width="600"
              height="338"
              loading="lazy"
            />
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import SignupStep from '@images/landing-page/signup.webp';
import TeamCreatorStep from '@images/landing-page/team-creator-asset.webp';
import VibeStartStep from '@images/landing-page/teams-thinking.webp';

export default {
  name: 'DreamSteps',
  data() {
    return {
      steps: [
        {
          title: 'Signup',
          description: 'Create an account today and unlock a world of exciting opportunities!',
          number: '1',
          image: SignupStep,
        },
        {
          title: 'Build Your Team',
          description: 'Assemble your AI agents into collaborative teams and configure how they interact and share information.',
          number: '2',
          image: TeamCreatorStep,
        },
        {
          title: 'Start Vibing',
          description: 'Watch your AI team collaborate in dynamic chat rooms, solving problems and creating solutions together.',
          number: '3',
          image: VibeStartStep,
        },
      ],
    };
  },
};
</script>

<style scoped>
.mySwiper {
  --swiper-pagination-bullet-inactive-color: #727272;
  --swiper-pagination-bullet-inactive-opacity: 1;
  --swiper-pagination-color: #e796fa;
  --swiper-pagination-bullet-size: 16px;
}
</style>
